import { render, staticRenderFns } from "./PatientSidebar.vue?vue&type=template&id=56e6515b&scoped=true"
import script from "./PatientSidebar.vue?vue&type=script&lang=js"
export * from "./PatientSidebar.vue?vue&type=script&lang=js"
import style0 from "./PatientSidebar.vue?vue&type=style&index=0&id=56e6515b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e6515b",
  null
  
)

export default component.exports